import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-loading',
    template: `
    <div class="app-loading-container">
      <div class="loading-container">
        <mat-spinner [diameter]="70"></mat-spinner>
      </div>
      <div class="img-container">
        <img src="assets/images/new_logo_civitrans.png" alt="loading-image" class="spinner-image" />
      </div>
    </div>

  `,
    styles: [
      `
        .app-loading-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 20px 30px;
        }

        .loading-container {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100%;
        }

        .img-container {
          display: flex;
          justify-content: center;
          width: 100%;
          text-align: center;
        }

        .spinner-image {
          width: 170px;
          height: 90px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
      `,
    ],
})
export class LoadingComponent {
    constructor(public dialogRef: MatDialogRef<LoadingComponent>) { }
}
